// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-select__menu-list{box-shadow:0 5px 15px 0 black;background-color:#222b35 !important;border-radius:.25rem}.react-select__option:hover{background-color:#2D5286 !important;color:rgba(255,255,255,0.94902) !important}.react-select__option--is-focused{background-color:#24A8A8 !important}\n", ""]);
// Exports
module.exports = exports;
